import athleteScholarship from '@/store/modules/scholarship/athlete-scholarship'
import athletesScholarship from '@/store/modules/scholarship/athletes-scholarship'
import athletesScholarshipCreate from '@/store/modules/scholarship/athlete-scholarship-create'
import athletesScholarshipDelete from '@/store/modules/scholarship/athlete-scholarship-delete'
import athletesScholarshipEdit from '@/store/modules/scholarship/athelte-scholarship-edit'

export default {
  athleteScholarship,
  athletesScholarship,
  athletesScholarshipCreate,
  athletesScholarshipDelete,
  athletesScholarshipEdit
}
